import { IApplicationState } from '../../types/redux';

/**
 * Выбирает хлебные крошки
 */
export const selectBreadCrumbs = ({ breadCrumb }: IApplicationState) => breadCrumb.path;
